// src/pages/Dashboard.js
import React from "react";
import { Card, Tabs, Tab } from "react-bootstrap";

const DashboardAdmin = () => {
  const overviewData = [
    {
      title: "Active Suppliers",
      value: 40,
      change: "+16.7%",
      changeText: "+2 from last month",
      bg: "bg-primary bg-opacity-10",
      icon: "🏭",
    },
    {
      title: "Active Buyers",
      value: 340,
      change: "+33.3%",
      changeText: "+1 from last month",
      bg: "bg-success bg-opacity-10",
      icon: "💰",
    },
    {
      title: "Open RFQs",
      value: 17,
      change: "+3",
      changeText: "from last month",
      bg: "bg-purple bg-opacity-10",
      icon: "📄",
    },
    {
      title: "Order Completed (30d)",
      value: 1540,
      change: "+0.2%",
      changeText: "+12 from last month",
      bg: "bg-warning bg-opacity-10",
      icon: "✅",
    },
  ];

  const recentActivity = [
    {
      id: "ORD-2024-001",
      date: "15 Jan 2024",
      buyer: "Acme Manufacturing",
      due: "15 Jan 2024",
      status: "Delivered",
    },
    {
      id: "ORD-2024-002",
      date: "08 Jan 2024",
      buyer: "Northline Foods",
      due: "15 Jan 2024",
      status: "Shipping",
    },
    {
      id: "ORD-2024-003",
      date: "22 Dec 2023",
      buyer: "Beacon Retail",
      due: "15 Jan 2024",
      status: "Delivered",
    },
  ];

  return (
    <div className="container my-4">
      {/* Overview Section */}
      <div className="row g-3 mb-4">
        {overviewData.map((item, i) => (
          <div className="col-md-3" key={i}>
            <div className={`card shadow-sm border-0 ${item.bg}`}>
              <div className="card-body">
                <div className="d-flex justify-content-between">
                  <h6 className="mb-2 text-muted">{item.title}</h6>
                  <span>{item.icon}</span>
                </div>
                <h4 className="fw-bold">{item.value}</h4>
                <small className="text-success fw-semibold">
                  {item.change}
                </small>{" "}
                <small className="text-muted">{item.changeText}</small>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Recent Activity */}
      <div className="card shadow-sm">
        <div className="card-body">
          <h6 className="mb-3 fw-bold">Recent Activity</h6>
          <table className="table align-middle">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Date</th>
                <th>Buyer</th>
                <th>Due</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {recentActivity.map((order, i) => (
                <tr key={i}>
                  <td>
                    <a href="#" className="text-primary fw-semibold">
                      {order.id}
                    </a>
                  </td>
                  <td>{order.date}</td>
                  <td>{order.buyer}</td>
                  <td>{order.due}</td>
                  <td>
                    <span
                      className={`badge ${
                        order.status === "Delivered"
                          ? "bg-success"
                          : "bg-info text-dark"
                      }`}
                    >
                      {order.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DashboardAdmin;
